angular.module('bb.external').factory('ExternalService', ExternalService);

ExternalService.$inject = ['$resource'];
function ExternalService($resource) {
  const OfferDetails = $resource('/external/:retsId/offer_details', {
    retsId: '@retsId',
  });

  const DashOfferDetails = $resource(
    '/external/dash/:dashboardId/offer_details',
    {
      dashboardId: '@dashboardId',
    },
  );

  const ExternalAppointments = $resource('/external/dash/:dashboardId/list', {
    dashboardId: '@dashboardId',
  });

  const DashboardNotifications = $resource(
    '/external/dash/:dashboardId/notifications',
    { dashboardId: '@dashboardId' },
  );

  const DashboardNotificationsForListing = $resource(
    '/external/dash/:dashboardId/listing/:listingId/notifications',
    {
      dashboardId: '@dashboardId',
      listingId: '@listingId',
    },
  );

  const DashboardPermissions = $resource(
    '/external/dash/:dashboardId/permissions/:appointmentId',
    {
      dashboardId: '@dashboardId',
      appointmentId: '@appointmentId',
    },
  );

  const DashboardStatus = $resource('/external/dash/:dashboardId/status', {
    dashboardId: '@dashboardId',
  });

  const Feedback = $resource(
    '/external/dash/:dashboardId/feedback/:appointmentId',
    {
      dashboardId: '@dashboardId',
      appointmentId: '@appointmentId',
    },
  );

  const Appointment = $resource(
    '/external/dash/:dashboardId/list/:appointmentId',
    {
      dashboardId: '@dashboardId',
      appointmentId: '@appointmentId',
    },
  );

  const ExternalListing = $resource(
    '/external/dash/:dashboardId/listings/:listingId',
    {
      dashboardId: '@dashboardId',
      listingId: '@listingId',
    },
  );

  const Agents = $resource('/external/dash/:dashboardId/agents', {
    dashboardId: '@dashboardId',
  });

  const LockboxPhoto = $resource('/external/dash/:dashboardId/lockbox_photo', {
    dashboardId: '@dashboardId',
  });

  function getOfferDetails(retsId) {
    return OfferDetails.get({ retsId }).$promise;
  }

  function getDashOfferDetails(dashboardId, listingId) {
    return DashOfferDetails.get({ dashboardId, listingId }).$promise;
  }

  function registerOffer(offer) {
    const registerOffer = new OfferDetails(offer);
    return registerOffer.$save();
  }

  function registerDashOffer(dashboardId, offer) {
    return DashOfferDetails.save({ dashboardId }, offer).$promise;
  }

  function getCoopAppointments(dashboardId) {
    return ExternalAppointments.get({ dashboardId }).$promise;
  }

  function getDashboardNotifications(dashboardId, appointmentId) {
    return DashboardNotifications.get({ dashboardId, appointmentId }).$promise;
  }

  function getDashboardNotificationsForListing(dashboardId, listingId) {
    return DashboardNotificationsForListing.get({ dashboardId, listingId })
      .$promise;
  }

  function saveDashboardNotifications(settings) {
    return DashboardNotifications.save(settings).$promise;
  }

  function getDashboardPermissions(dashboardId, appointmentId) {
    return DashboardPermissions.get({ dashboardId, appointmentId }).$promise;
  }

  function saveDashboardStatus(status) {
    return DashboardStatus.save(status).$promise;
  }

  function submitFeedback(feedback, appointmentId, dashboardId) {
    return Feedback.save({ feedback, appointmentId, dashboardId }).$promise;
  }

  function getFeedback(dashboardId, appointmentId) {
    return Feedback.get({ dashboardId, appointmentId }).$promise;
  }

  function getAppointment(dashboardId, appointmentId) {
    return Appointment.get({ dashboardId, appointmentId }).$promise;
  }

  function getAgentsForSeller(dashboardId) {
    return Agents.get({ dashboardId }).$promise;
  }

  function getLockboxPhoto(dashboardId) {
    return LockboxPhoto.get({ dashboardId }).$promise;
  }

  function getExternalListing(dashboardId, listingId) {
    return ExternalListing.get({ dashboardId, listingId }).$promise;
  }

  return {
    getOfferDetails,
    registerOffer,
    registerDashOffer,
    getDashOfferDetails,
    getCoopAppointments,
    getDashboardNotifications,
    getDashboardNotificationsForListing,
    saveDashboardNotifications,
    getDashboardPermissions,
    saveDashboardStatus,
    submitFeedback,
    getFeedback,
    getAppointment,
    getAgentsForSeller,
    getLockboxPhoto,
    getExternalListing,
  };
}

export {};
